import React, { useState } from 'react';
import Container from '@ui/container/container';
import { ICONS } from '@ui/icons/types';
import Icon from '@ui/icons/icon';
import Button from '@ui/buttons/button/button';
import Text from '@ui/text/text/text';
import { MaskedValueType } from './container-types';
import OptionalComponent from '@ui/optional-component/optional-component';

interface MaskedValueContainerProps {
  value: string;
  type?: MaskedValueType;
}

const MaskedValueContainer: React.FC<MaskedValueContainerProps> = ({ value, type = '' }) => {
  const [isMasked, setIsMasked] = useState(type === MaskedValueType.PASSWORD);

  let displayedValue = value;

  if (type === MaskedValueType.PASSWORD && isMasked) {
    displayedValue = value.replace(/-/g, ' ').replace(/\w/g, '•');
  }

  return (
    <Container
      borderWidth="1px"
      borderColor="var(--gray-400)"
      borderRadius="100px"
      height="40px"
      className="padding-h-16 S2 flex-1 flex gap-10 ai-center jc-space-between"
      style={{ overflowX: 'auto' }}
    >
      <Text
        className="P2"
        color="var(--gray-400)"
        whiteSpace="no-wrap"
        style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none' }}
      >
        {displayedValue}
      </Text>
      <OptionalComponent display={type === MaskedValueType.PASSWORD}>
        <Button
          height="18px"
          className="padding-0"
          onClick={() => setIsMasked(!isMasked)}
          aria-label={isMasked ? 'Show value' : 'Hide value'}
        >
          <Icon name={isMasked ? ICONS.VIEWERS_EYE : ICONS.VIEWERS_EYE_OFF} color="var(--gray-400)" size={18} />
        </Button>
      </OptionalComponent>
    </Container>
  );
};

export default MaskedValueContainer;
